<template>
  <div>
    <div v-for="item in model" :key="item.index">
      <IndexableItem
        :title="title"
        class="mb-2"
        is-readonly
        :disabled="disabled"
        :value="item.text"
        :index="item.index"
        @remove="removeItem(item)"
      />
    </div>

    <IndexableItem
      :title="title"
      v-if="!disabled"
      v-model="newText"
      :index="nextItemIndex"
    />

    <Error v-if="hasError" variant="no-border" :message="errorMsg" />

    <div v-if="!disabled" class="section__actions">
      <ActionButton
        type="button"
        :text="actionName"
        i="fas fa-file-plus"
        variant="success"
        class="px-4"
        :disabled="!newText.trim()"
        @click="addItem"
      />
    </div>
  </div>
</template>

<script>
import Error from "custom-error";
import ActionButton from 'ActionButton';
import IndexableItem from './IndexableItem.vue';

export default {
  name: 'IndexableGroup',
  components: {
    Error,
    ActionButton,
    IndexableItem
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    actionName: {
      type: String,
      default: 'Añadir',
    },
    errorMsg: {
      type: String,
      default: 'Campo requerido.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: [],
      newText: '',
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.model)) {
          this.model = [...newValue].sort((a, b) => a.index - b.index);
        }
      },
      immediate: true,
      deep: true,
    },
    model: {
      handler(newValue) {
        this.$emit('input', [...newValue].sort((a, b) => a.index - b.index));
      },
      deep: true,
    },
  },
  computed: {
    nextItemIndex() {
      const maxIndex = this.model.length ? Math.max(...this.model.map(s => s.index)) : 0;
      return maxIndex + 1;
    },
  },
  methods: {
    addItem() {
      const trimmed = this.newText.trim();
      if (!trimmed) return;

      const item = {
        text: trimmed,
        index: this.nextItemIndex,
      };

      this.model = [...this.model, item];
      this.newText = '';
    },
    removeItem(item) {
      const filtered = this.model.filter(s => s.index !== item.index);
      this.model = filtered.map((s, i) => ({
        ...s,
        index: i + 1,
      }));
    },
  },
};
</script>

<style scoped>
.section__actions {
  padding: 20px 0;
  display: flex;
  align-items: end;
  justify-content: end;
}
</style>